/**
 * Core Web Vitals reporting.
 *
 * The CRA default called getCLS/getFID/... which web-vitals v4 no longer
 * exports, so it was dead code. This uses the current API (and INP, which
 * replaced FID as a Core Web Vital in 2024).
 *
 * Set REACT_APP_VITALS_URL to POST measurements somewhere; otherwise this
 * logs in development and stays silent in production.
 */
const reportWebVitals = (onPerfEntry) => {
  const handler =
    onPerfEntry && onPerfEntry instanceof Function ? onPerfEntry : defaultHandler;

  import('web-vitals')
    .then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
      onCLS(handler);
      onINP(handler);
      onLCP(handler);
      onFCP(handler);
      onTTFB(handler);
    })
    .catch(() => {
      /* measurement must never break the page */
    });
};

function defaultHandler(metric) {
  const endpoint = process.env.REACT_APP_VITALS_URL;
  if (endpoint) {
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
      path: window.location.pathname,
    });
    // sendBeacon survives the page being closed mid-flight.
    if (navigator.sendBeacon) navigator.sendBeacon(endpoint, body);
    else fetch(endpoint, { method: 'POST', body, keepalive: true }).catch(() => {});
    return;
  }
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(`[web-vitals] ${metric.name}: ${Math.round(metric.value)} (${metric.rating})`);
  }
}

export default reportWebVitals;
